<template>
  <bg-style
    v-if="enabled"
    v-show="showActivity"
    v-imloading="loading"
    class="activity-widget"
    :class="$store.getters.isMobile ? 'activity_content_mobile relative' : 'activity_content_desk relative'"
    :bg="model.background"
    :is-disabled="$store.getters.isStandAloneMode"
    :mobile-bg="model.mobileBackground"
  >
    <module-block :bg="model.background" :mobile-bg="model.mobileBackground">
      <div v-if="model.titleVisible" class="activity-widget__title items-center relative" :class="{ 'flex': hasHelpIcon }">
        <rich-text
          v-model="model.title"
          :editing="editing"
          :stroke.sync="model.titleStroke"
          :disabled="!editing"
          placement="top"
          theme="snow"
          :force-wrap="hasHelpIcon"
        />
        <img v-if="hasHelpIcon" class="cursor-pointer help-icon" :src="model.helpIcon.backgroundImage" alt="" @click="handleShowRuleModal">
      </div>
      <row-content v-if="model.layout === AccumulationLayoutEnum.Row" :model="model" :type="AccumulationLayoutEnum.Row" :editing="editing" :is-mobile="$store.getters.isMobile" @show-loading="showLoading" @hide-loading="hideLoading" @show-detail="onItemClick" @end="onActivityEnd" @show="onActivityShow"/>
      <col-content v-else-if="model.layout === AccumulationLayoutEnum.Col" :model="model" :editing="editing" :type="AccumulationLayoutEnum.Col" :is-mobile="$store.getters.isMobile" @show-loading="showLoading" @hide-loading="hideLoading" @show-detail="onItemClick" @end="onActivityEnd" @show="onActivityShow"/>
      <div class="activity-widget__describe">
        <rich-text
          v-if="model.subtitleVisible"
          v-model="model.subtitle"
          :stroke.sync="model.subTitleStroke"
          :editing="editing"
          :disabled="!editing"
          placement="top"
          theme="snow"
        />
      </div>
    </module-block>
    <info-detail ref="info" :data="currentRow" :is-mobile="$store.getters.isMobile" />
    <el-dialog :width="ruleDialogWidth" :visible.sync="ruleVisible" :modal="!editing" class="accumulation-rule-dialog" :class="{ 'is-edit': editing, 'is-mobile': $store.getters.isMobile}">
      <div class="accumulation-rule-dialog__content">
        <rich-text v-model="model.ruleTitle" :editing="editing" :disabled="!editing" placement="top" theme="snow" />
        <rich-text v-model="model.ruleDescribe" class="mt-5" :editing="editing" :disabled="!editing" />
      </div>
    </el-dialog>
  </bg-style>
</template>

<script>
import { Dialog } from 'element-ui'
import RowContent from './rowContent.vue'
import ColContent from './colContent.vue'
import InfoDetail from './info.vue'
import richText from '~/components/richText'
import Bus from '~/site/model/bus'
import { AccumulationLayoutEnum } from '~/enums/data'
import ModuleBlock from '~/components/common/ModuleBlock.vue'

export default {
  name: 'ActivityWidgetEdit',
  components: {
    [Dialog.name]: Dialog,
    ModuleBlock,
    InfoDetail,
    richText,
    RowContent,
    ColContent
  },
  props: {
    model: {
      type: Object,
      default() {
        return {}
      },
    },
    editing: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      enabled: true,
      ruleVisible: false,
      AccumulationLayoutEnum,
      currentRow: {},
      loading: false,
      showActivity: false
    }
  },
  computed: {
    hasHelpIcon() {
      return this.model.helpIcon.backgroundImage && this.model.helpIcon.backgroundImageShow
    },
    ruleDialogWidth() {
      return this.$store.getters.isMobile ? '320px' : '500px'
    }
  },
  beforeDestroy() {
    Bus.$off('reloadActivity')
  },
  methods: {
    onActivityShow() {
      this.showActivity = true
    },
    onItemClick(data) {
      this.currentRow = data
      this.$refs.info.init()
    },
    onActivityEnd() {
      this.enabled = false
      this.model.__hide = true
    },
    handleShowRuleModal() {
      this.ruleVisible = true
    },
    showLoading() {
      this.loading = true
    },
    hideLoading() {
      this.loading = false
    }
  }
}
</script>

<style lang="less">
.accumulation-rule-dialog {
  .el-dialog__header {
    padding: 0;
    .el-dialog__headerbtn {
      top: 10px;
      right: 10px;
      .el-icon {
        font-weight: bold;
      }
    }
  }
  &.is-edit&.is-mobile {
    left: 20px;
  }
}
.activity-widget {
  .activity_desc {
    margin-top: 20px;
  }
}
.activity_content_desk {
  padding: 20px 0;
  .help-icon {
    max-width: 40px;
    max-height: 40px;
    margin-left: 20px;
  }
}

.activity_content_mobile {
  padding: 10px;
  .activity-widget__title {
    padding: 0 11px;
    .help-icon {
      max-width: 30px;
      max-height: 30px;
      margin-left: 10px;
    }
  }
  .activity-widget__describe {
    padding: 0 11px;
  }
}
</style>
